import { render } from "./RoteiroPublico.vue?vue&type=template&id=5b11dc8b&scoped=true"
import script from "./RoteiroPublico.vue?vue&type=script&lang=js"
export * from "./RoteiroPublico.vue?vue&type=script&lang=js"

import "./RoteiroPublico.vue?vue&type=style&index=0&id=5b11dc8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b11dc8b"]])

export default __exports__